/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["fuse-countdown{display:flex;flex-direction:row;align-items:center;justify-content:center}fuse-countdown .fuse-countdown{display:flex;flex-direction:row;align-items:center;justify-content:center;text-align:center}fuse-countdown .fuse-countdown .time{display:flex;flex-direction:column;padding:0 12px}fuse-countdown .fuse-countdown .time .value{font-size:34px;line-height:34px;padding-bottom:8px}fuse-countdown .fuse-countdown .time .title{color:rgba(0,0,0,.54)}"];
export { styles as styles };
